import React from "react"
import {observer} from "mobx-react"
import {injectIntl, FormattedMessage} from "react-intl"
import Grid from "@material-ui/core/Grid"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"

// special import for Material-UI binding
import bindings from "../../../../../global/ui/globalUISchemeBindings"
import XsTable from "../../../../../global/ui/xsTable/xsTable"
// import XsDateTimePicker from "../../../../../global/ui/xsDateTimePicker/xsDateTimePicker"
// import XsAutocomplete from "../../../../../global/ui/xsInput/xsAutocomplete"
import XsInput from "../../../../../global/ui/xsInput/xsInput"
// import api from "../../../actions/api"
import XsButton from "../../../../../global/ui/xsButton/xsButton"
import XsIconButton from "../../../../../global/ui/xsButton/xsIconButton"
// import RouterStore from "../../../../../global/store/RouterStore"
// import DrugReportStore from "../../../stores/DrugReportStore"
import NcziU01ReportStore from "../../../stores/NcziU01ReportListStore"
import UIStore from "../../../stores/UIStore"
import TableStore from "../../../stores/TableStore"
import XsLoading from "../../../../../global/ui/xsLoading/xsLoading"
import moment from "moment"
// import ExportDrugReportDialog from "./exportDrugReportDialog"
// import moment from "moment"

@injectIntl
@observer
export default class ncziU01ReportList extends React.Component {
	constructor(props) {
		super(props)

		UIStore.isFormSaving = false
		NcziU01ReportStore.reportList = []

		const hooks = {
			onSubmit() {},
			onSuccess(form) {
				if (
					TableStore.tables.hasOwnProperty("ncziU01ReportList") &&
					TableStore.tables["ncziU01ReportList"].hasOwnProperty("index")
				) {
					delete TableStore.tables["ncziU01ReportList"]["index"]
				}

				NcziU01ReportStore.loadNcziU01Report(form, props.intl.formatMessage({id: "Common.label.yearFilterRequired"}))
			},
			onError() {}
		}

		if (isEmpty(NcziU01ReportStore.formRef)) {
			NcziU01ReportStore.formRef = new MobxReactForm(
				{
					fields: {
						year: {
							label: <FormattedMessage id="Common.label.year" />,
							value: moment()
								.subtract("1", "year")
								.format("YYYY")
						}
					}
				},
				{plugins: {dvr: validatorjs}, hooks, bindings}
			)
		}

		this.form = NcziU01ReportStore.formRef

		// NcziU01ReportStore.loadNcziU01Report(this.form, props.intl.formatMessage({id: "Common.label.yearFilterRequired"}))
		// DrugReportStore.loadDrugReport(this.form)
	}

	// onHandleRowClick = (dataRow) => {
	// 	if (dataRow.person_id) {
	// 		RouterStore.push(`/patient?id=${dataRow.person_id}`)
	// 	}
	// }

	render() {
		NcziU01ReportStore.isChangedFilter(this.form.values())

		return (
			<Grid container className="xs-ncziA01-list">
				<Grid item xs={12}>
					<Grid container spacing={8} alignItems="center">
						<Grid item xs={2}>
							<XsInput white field={this.form.$("year")} placeholder={"napr. 2019"} />
						</Grid>
						<Grid item xs={7} className="pb-0">
							<XsIconButton
								rect
								className="xs-default xs-outline"
								tooltip={this.props.intl.formatMessage({id: "Common.label.applyFilter"})}
								onClick={this.form.onSubmit}
								icon={<i className="far fa-search fa-lg xs-greyDefault"></i>}
							/>
							{isEmpty(this.form.$("year").value) && (
								<span className="xs-table-no-data ml-6 pa-2">
									<FormattedMessage id="Common.label.yearFilterRequired" />
								</span>
							)}
						</Grid>
						<Grid item xs={3}>
							<Grid container justify="flex-end" spacing={8}>
								<Grid item>
									<XsButton
										className="xs-primary"
										text={<FormattedMessage id="Common.label.ExportXML" />}
										icon={<i className="fal fa-file-excel fa-lg" />}
										onClick={() => {
											// DrugReportStore.open()
											NcziU01ReportStore.loadNcziU01Report(
												this.form,
												this.props.intl.formatMessage({id: "Common.label.yearFilterRequired"}),
												true
											)
										}}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					{UIStore.isFormSaving ? (
						<XsLoading />
					) : NcziU01ReportStore.changedFilters ? (
						<div className="xs-table-no-data pa-3 borderRadius-1 mt-8">
							<i className="far fa-search fa-lg mr-3 pointer" onClick={this.form.onSubmit}></i>
							<FormattedMessage id="Common.label.changeFilterSettingsClkickOnTheMagnifyingToApplyThem" />
						</div>
					) : (
						<XsTable
							config={{
								columnDefs: {
									country_eu: {
										title: <FormattedMessage id="Common.label.state_code" />,
										type: "string",
										design: {
											width: "30px"
										},
										sortable: true
									},
									health_care: {
										title: <FormattedMessage id="Common.label.health_care_type" />,
										type: "string",
										design: {
											width: "350px"
										},
										sortable: true
									},
									health_care_type_text: {
										title: <FormattedMessage id="Common.label.health_care_group" />,
										type: "string",
										design: {
											width: "100px"
										},
										sortable: true
									},
									dgn_code: {
										title: <FormattedMessage id="Common.label.dgn_code" />,
										type: "number",
										design: {
											width: "50px"
										},
										sortable: true
									},
									payment: {
										title: <FormattedMessage id="Common.label.payment" />,
										type: "number",
										design: {
											width: "50px"
										},
										sortable: true
									},
									payment_value: {
										title: <FormattedMessage id="Common.label.payment_value" />,
										type: "number",
										design: {
											width: "50px"
										},
										sortable: true
									}
								},
								options: {
									name: "ncziU01ReportList",
									showCursor: true,
									// selectRow: true,
									// defaultSort: {columnName: "stamp", sortDirection: "asc"},
									onRowClick: () => {
										// this.onHandleRowClick(dataRow)
									},
									mapper: (dataRow) => {
										return Object.assign({}, dataRow, {
											health_care: `${dataRow.health_care_type} - ${dataRow.health_care_type_name}`,
											health_care_type_text: `${dataRow.health_care_group} - ${dataRow.health_care_group_name}`
										})
									}
								},
								dataSource: NcziU01ReportStore.reportList
							}}
						/>
					)}
				</Grid>
				{/* <ExportDrugReportDialog form={this.form} /> */}
			</Grid>
		)
	}
}
